import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Fastpris', path: '/ydelser/fastpris' },
    { name: 'Spot', path: '/ydelser/spot' },
    { name: 'Portefølje', path: '/ydelser/portefoelje' },
    { name: 'Udbud', path: '/ydelser/udbud' },
  ];

  const quickLinks = [
    { name: 'Forside', path: '/' },
    { name: 'Om os', path: '/om-os' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <footer className="bg-[#111a36] text-white pt-16 pb-8 border-t border-brand-light/10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Company Info */}
        <div className="space-y-6">
          <div className="flex flex-col items-start gap-1">
            <Link to="/" className="inline-block bg-white p-2 rounded-sm">
              <img 
                src="https://assets.auxodev.dk/assets/57398cfb-6e5d-4ba8-a3b9-c24b8dc48392/energi-logo1.png" 
                alt="EnergiMælgere.dk Logo" 
                className="h-16 w-auto object-contain"
              />
            </Link>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            EnergiMælgere.dk er udbyder af indkøbs strategi udarbejdet efter din virksomheds behov samt finansielle elaftaler. Vi har viden og kendskab til markedet så vi kan forklare, hvordan dette hænger sammen.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xs font-bold uppercase tracking-widest text-brand-orange mb-6">Hurtige links</h3>
          <ul className="space-y-3">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-gray-400 hover:text-brand-orange transition-colors text-sm">
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-xs font-bold uppercase tracking-widest text-brand-orange mb-6">Ydelser</h3>
          <ul className="space-y-3">
            {services.map((service) => (
              <li key={service.path}>
                <Link to={service.path} className="text-gray-400 hover:text-brand-orange transition-colors text-sm">
                  {service.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xs font-bold uppercase tracking-widest text-brand-orange mb-6">Kontakt os</h3>
          <ul className="space-y-4 text-sm text-gray-400">
            <li className="flex items-start gap-3">
              <i className="fa-regular fa-location-dot text-brand-orange mt-1" />
              <span>
                <strong>EnergiMælgere.dk</strong><br />
                Niels Jernes Vej 10<br />
                9220 Aalborg Ø
              </span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-regular fa-phone text-brand-orange" />
              <a href="tel:+4550358378" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                50 358 378
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-regular fa-envelope text-brand-orange" />
              <a href="mailto:info@energimaeglere.dk" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                info@energimaeglere.dk
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
        <p>© {currentYear} EnergiMælgere.dk. Alle rettigheder forbeholdes. KnowHow GROUP</p>
        <div className="flex gap-6">
          <Link to="/privatlivspolitik" className="hover:text-white transition-colors">Privatlivspolitik</Link>
          <Link to="/betingelser" className="hover:text-white transition-colors">Betingelser</Link>
        </div>
      </div>
    </footer>
  );
}
